const education = [
  {
    year: "2015 - 2017",
    subject: "Computer Programming",
    institute: "Humber Institute of Technology and Advanced Learning",
    location: "Toronto, ON",
    description:
      "Comprehensive diploma program covering full-stack development, algorithms, data structures, and software engineering principles.",
  },
  {
    year: "2018 - 2024",
    subject: "Professional Development Courses",
    institute: "Udemy - Continuous Learning",
    location: "Online",
    description:
      "The Modern GraphQL Bootcamp (Node.js & Apollo) - Andrew Mead | Node.js, Express & MongoDB Dev to Deployment - Brad Traversy | React Front To Back - Brad Traversy | Azure (AZ-900) - Scott Duffy",
  },
];

export default education;
